import { Link } from "react-router-dom";
import { recommendList } from "@/mocks/recommend";
import type { RecommendItem } from "@/types/content";

export default function RecommendSection() {
  const items = (recommendList as RecommendItem[]).slice(0, 6);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/detail/recommend/${item.id}`}
          className="group block cursor-pointer"
        >
          <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden border border-background-200">
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 香蕉动漫`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-xs font-bold text-primary-400">
              <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center"></i>
              {item.score}
            </span>
            <span className="absolute bottom-2 left-2 rounded-md bg-primary-500/95 px-1.5 py-0.5 text-[10px] font-bold text-foreground-950">
              {item.year}
            </span>
          </div>
          <h3 className="mt-2.5 font-medium text-sm text-foreground-950 line-clamp-1 group-hover:text-accent-600 transition-colors">
            {item.title}
          </h3>
          <div className="mt-1.5 flex flex-wrap gap-1">
            {item.genres.slice(0, 2).map((g) => (
              <span
                key={g}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900"
              >
                {g}
              </span>
            ))}
          </div>
        </Link>
      ))}
    </div>
  );
}